import request from '@/utils/request'

// 获取公司实时采集器状态
export function collectorStatusQuery(data) {
    return request({
        url: '/db/screen/collector-status-query',
        method: 'post',
        data
    })
}

// 采集器所属地区列表实时状态查询
export function placeCollectorStatusQuery(data) {
  return request({
    url: '/db/screen/place-collector-status-query',
    method: 'post',
    data
  })
}

// 全国采集器预警信息查询
export function hospCollectorWaringQuery(data) {
  return request({
    url: '/db/screen/hosp-collector-waring-query',
    method: 'post',
    data
  })
}

// 全国采集器预警信息查询
export function iotPlatformInfo(data) {
  return request({
    url: '/db/screen/iot-platform-info',
    method: 'post',
    data
  })
}

// 获取用户下所有医院以及医院下设备的数量
export function queryHospCollectCount(data) {
  return request({
    url: '/db/hosp/hosp-collector-count-query',
    method: 'post',
    data
  })
}


// 地图医院坐标列表
export function mapHospQuery(data) {
  return request({
    url: '/db/hosp/map-hosp-query',
    method: 'post',
    data
  })
}

// 获取各省市医院数据
export function provinceHospQuery(data) {
  return request({
    url: '/db/hosp/province-hosp-query',
    method: 'post',
    data
  })
}

// 实时运行参数预警
export function eqpWarnLogListQuery(data) {
  return request({
    url: '/db/screen/eqp-warn-log-list-query',
    method: 'post',
    data
  })
}

// 设备环境监控
export function eqpWarnStatusQuery(data) {
  return request({
    url: '/db/screen/eqp-warn-status-query',
    method: 'post',
    data
  })
}
